module.exports = __webpack_public_path__ + "static/media/lower.1fe2e69d.svg";